import { render, staticRenderFns } from "./updateProfile.vue?vue&type=template&id=ce217a66&"
import script from "./updateProfile.vue?vue&type=script&lang=ts&"
export * from "./updateProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports